import { connect } from 'react-redux';
import { CardPrice } from "../../../../components/CardPrice";
import { getTariffFee, getTariffOldFee } from "../../../../store/blocks/tariffs/tariffSelectors";
export var TariffPrice = connect(function (state) {
  return {
    oldPrice: getTariffOldFee(state),
    price: getTariffFee(state)
  };
})(CardPrice);